import getHelper from '../../../services/getHelper';
import { RecruiterJobPosting } from '../types';

export default getHelper('/recruiters/:id', {
  jobPostings: getHelper<RecruiterJobPosting>('/job-postings/:id'),
});
